import { render } from "./ExampleGame.vue?vue&type=template&id=05369786"
import script from "./ExampleGame.vue?vue&type=script&lang=js"
export * from "./ExampleGame.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__